import { render, staticRenderFns } from "./V2SPImageInput.vue?vue&type=template&id=49190ba3&scoped=true&"
import script from "./V2SPImageInput.vue?vue&type=script&lang=ts&"
export * from "./V2SPImageInput.vue?vue&type=script&lang=ts&"
import style0 from "./V2SPImageInput.vue?vue&type=style&index=0&id=49190ba3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49190ba3",
  null
  
)

export default component.exports